<template>
  <li class="history-item" :class="history.type === 'refresh'? 'refresh-item' : ''">
    <div class="item-inner" v-if="history.type === 'flip'">
      <Item role="li" class="item"
        :type="history.pool === 1 ? 'light' : 'normal'"
        :nums="history.nums"
        :imgSrc="history.src" />
    </div>
    <div class="item-desc" v-else>{{$bus.transify['FLIP_REFRESH_POOL']}}</div>
    <div class="item-name">
      <p v-marquee>
        <span>{{history.name}}</span>
      </p>
    </div>
    <div class="history-cost">
      <p class="cost">
        <i class="diamond"></i>
        <span class="gem-nums" :class="history.price === 0 ? 'free': ''">
          {{history.price === 0 ? $bus.transify['FLIP_FREE'] : history.price}}
        </span>
      </p>
    </div>
    <div class="history-time">{{time}}</div>
  </li>
</template>

<script>
import Item from '@/components/common/Item.vue'
export default {
  props: {
    time: String,
    history: Object
  },
  components: {
    Item
  }
}
</script>

<style lang="scss" scoped>
.history-item {
  @include px2res(height, 126);
  @include px2res(font-size, 24);
  @include flexrc;
  color: #FFF7E1;
  justify-content: space-around;
  width: 100%;
  position: relative;
  white-space: normal;
  .item-inner {
    @include px2res(width, 160);
    @include flexrc;
  }
  .item.light {
    animation: none !important;
    box-shadow: none !important;
  }
  .item {
    @include px2res(width, 100);
    @include px2res(height, 100);
  }
  .item-desc {
    @include px2res(width, 160);
    @include px2res(padding, 0, 10);
    @include px2res(font-size, 24);
    line-height: 1;
    text-transform: uppercase;
    text-align: center;
  }
  .item-name {
    @include px2res(width, 120);
    @include px2res(height, 34);
    @include px2res(margin, 0, 40, 0, 0);
    overflow: hidden;
    p {
      overflow: hidden;
      text-align: center;
      white-space: nowrap;
    }
  }
  .history-cost {
    @include flexrc;
    justify-content: flex-start;
    @include px2res(width, 126);
    font-weight: 500;
    white-space: nowrap;
    .cost {
      @include flexrc;
      position: relative;
      line-height: 1;
      align-items: flex-end;
      text-transform: uppercase;
      @include px2res(font-size, 24);
      .diamond {
        @include px2res(width, 28);
        @include px2res(height, 25);
        @include px2res(margin-right, 4);
      }
      .gem-nums.free {
        @include px2res(font-size, 20);
      }
    }
  }
  .history-time {
    text-align: center;
    line-height: 1;
    @include px2res(width, 250);
  }
}
.history-item.refresh-item {
  @include px2res(height, 114);
}
</style>



// WEBPACK FOOTER //
// src/components/history/item.vue